import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors } from '~styles/theme.stylex';
export const styles = {
  container: {
    maxWidth: "xzsb0xr",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  footer: {
    borderTopWidth: "x178xt8z",
    borderTopStyle: "x13fuv20",
    borderTopColor: "xqu00je",
    paddingTop: "x6gltce",
    paddingBottom: "x17r0vjz",
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "xilar1o",
    rowGap: null,
    columnGap: null,
    fontSize: "xkpwil5",
    $$css: true
  },
  brand: {
    width: "xh8yej3",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  brandText: {
    fontSize: "x6u19be",
    color: "xarw3lm",
    $$css: true
  },
  link: {
    color: "xarw3lm",
    $$css: true
  }
};